import { Clean } from '../../cleans'
import { TaskJobType } from '../tasks.types'

/** Typeguard specific to the FA - prefer this over the function with the same name in grimoire when in the FA */
export const taskIsClean = (task: {
  jobType: TaskJobType[]
}): task is Clean => {
  return task.jobType.includes('standard')
}
